import { Controller } from '@hotwired/stimulus'
import escapeHtml from '../../utils/sanitize'
import fetchWithHandlingLoginRedirect from '../../modules/utils/fetchWithHandlingLoginRedirect'

export default class extends Controller {
  static values = { type: String }
  static targets = ['account', 'log', 'count', 'addButton', 'confirmationButtons', 'loading', 'banner']

  accountId = null
  count = 0
  logId = null

  handleMercureEvent (mercureEvent) {
    const FixtureEventType = {
      fixtures_add_succeeded: 'fixtures.add.succeeded',
      fixtures_add_failed: 'fixtures.add.failed'
    }

    const { fixtureType, eventType, event } = mercureEvent.detail.data

    const controllerElement = document.querySelector('[data-controller="fixture"][data-fixture-type-value="' + fixtureType + '"]')
    const bannerElement = controllerElement.querySelector('[data-fixture-target="banner"]')
    const loadingElement = controllerElement.querySelector('[data-fixture-target="loading"]')

    if (event === FixtureEventType.fixtures_add_succeeded) {
      bannerElement.classList.add('alert-success')
      bannerElement.classList.remove('alert-danger')
      bannerElement.innerHTML = 'Fixtures successfully completed!'
      bannerElement.classList.remove('d-none')
      $(bannerElement).fadeIn()
      $(bannerElement).delay(2000).fadeOut()

      loadingElement.classList.add('d-none')
    }

    if (event === FixtureEventType.fixtures_add_failed) {
      bannerElement.classList.remove('alert-success')
      bannerElement.classList.add('alert-danger')
      bannerElement.innerHTML = 'Failed to create fixtures. If problem persists, please contact support.'
      bannerElement.classList.remove('d-none')
      $(bannerElement).fadeIn()
      $(bannerElement).delay(2000).fadeOut()

      loadingElement.classList.add('d-none')
    }
  }

  disconnect () {
    super.disconnect()
    document.removeEventListener('MercureEvent', this.handleMercureEvent)
  }

  connect () {
    document.addEventListener('MercureEvent', this.handleMercureEvent)

    const accountDropdownConfig = {
      fullTextSearch: 'exact',
      placeholder: 'Account',
      clearable: true,
      saveRemoteData: false,
      apiSettings: {
        cache: 'false',
        url: '/internal/api/accounts',
        onResponse: (listAccountsResponse) => {
          const response = { results: [] }
          listAccountsResponse.results.forEach((account) => {
            const accountLogo = account.logo_image_url ? account.logo_image_url : 'assets/img/theme/account.jpg'
            response.results.push({
              name: '<div><img src="' + accountLogo + '" class="rounded-circle profile-avatar assignee" height="20px" width="20px"/>' + '<span class="ml-2">' + escapeHtml(account.name) + '</span></div>',
              value: account.id
            })
          })

          return response
        }
      },
      onChange: (value) => {
        this.accountId = value
        if (this.hasLogTarget) {
          $(this.logTarget).dropdown('clear')
          if (this.accountId) {
            this.logTarget.classList.remove('disabled')
          } else {
            this.logTarget.classList.add('disabled')
          }
        }

        this.checkCanAdd()
      }
    }

    this.countTarget.addEventListener('input', () => {
      let value = parseInt(this.countTarget.value)
      if (isNaN(value) || value < 0) {
        value = 0
      } else if (value > 1000000) {
        value = 1000000
      }
      this.countTarget.value = value

      this.checkCanAdd()
    })

    const logDropdownConfig = {
      fullTextSearch: 'exact',
      placeholder: 'Log',
      clearable: true,
      filterRemoteData: true,
      saveRemoteData: false,
      apiSettings: {
        cache: false,
        url: '/internal/api/logs?account_id={accountId}',
        beforeSend: (settings) => {
          settings.urlData.accountId = this.accountId
          return settings
        },
        onResponse: function (indexLogsResponse) {
          const response = { results: [] }
          indexLogsResponse.results.forEach((log) => {
            response.results.push({
              name: '<span>' + escapeHtml(log.name) + '</span>',
              value: log.id
            })
          })

          return response
        }
      },
      onChange: (value) => {
        this.logId = value

        this.checkCanAdd()
      }
    }

    $(this.accountTarget).dropdown(accountDropdownConfig)
    if (this.hasLogTarget) {
      $(this.logTarget).dropdown(logDropdownConfig)
    }
  }

  checkCanAdd () {
    if (this.accountId && this.countTarget.value > 0) {
      this.addButtonTarget.removeAttribute('disabled')
    } else {
      this.addButtonTarget.setAttribute('disabled', 'disabled')
    }
  }

  add () {
    this.bannerTarget.classList.add('d-none')
    this.confirmationButtonsTarget.classList.remove('d-none')
  }

  cancel () {
    this.confirmationButtonsTarget.classList.add('d-none')
    this.addButtonTarget.setAttribute('disabled', 'disabled')
  }

  confirm () {
    this.element.classList.add('opacity-5')
    this.confirmationButtonsTarget.classList.add('d-none')
    this.addButtonTarget.setAttribute('disabled', 'disabled')
    this.loadingTarget.classList.remove('d-none')

    const data = new FormData()
    data.append('type', this.typeValue)
    data.append('account', this.accountId)
    data.append('count', this.countTarget.value)
    if (this.logId) {
      data.append('log', this.logId)
    }
    fetchWithHandlingLoginRedirect('/internal/api/fixtures', { method: 'POST', body: data })
      .then(response => {
        this.element.classList.remove('opacity-5')
        this.addButtonTarget.removeAttribute('disabled')

        if (!response.ok) {
          return Promise.reject(response)
        }

        return response.json()
      }).then(data => {
        this.bannerTarget.classList.add('alert-success')
        this.bannerTarget.classList.remove('alert-danger')
        this.bannerTarget.innerHTML = data.notices.message
        this.bannerTarget.classList.remove('d-none')
        $(this.bannerTarget).fadeIn()
        $(this.bannerTarget).delay(2000).fadeOut()
      })
      .catch((response) => {
        this.bannerTarget.classList.remove('alert-success')
        this.bannerTarget.classList.add('alert-danger')
        this.bannerTarget.innerHTML = 'Error.'
        this.bannerTarget.classList.remove('d-none')
        $(this.bannerTarget).fadeIn()
        $(this.bannerTarget).delay(2000).fadeOut()

        this.loadingTarget.classList.add('d-none')
      })
  }
}
